
import useCampaignMission from '@/hook/useCampaignMission/useCampaignMission';
import MissionsRender from '@/components/missions-render-v2/missions-render';
import { LoaderContainer } from "../logged-page/style-component";
import { SpaceshipLoader } from "@/components/spaceship-loader/spaceship-loader";
import { useParams } from "react-router-dom";
import SEOHelmet from '@/components/SEOHelmet/SEOHelmet';
import { EmptyGridMessageContainer } from '@/components/grid-cards/style-component';
import EmojiLookDown from "@/assets/icons/emoji-look-down/emoji-look-down.svg"
import { determineProjectName, amplitudeAddTrack } from '@/utils/amplitud/event-track';
import { useEffect, useRef } from 'react';

const MissionPageV2: React.FC = () => {
  const { campaignId, missionId } = useParams();
  const {
    campaign,
    requirements,
    missions,
    participant,
    loadingCampaignOrParticipant,
  } = useCampaignMission(Number(campaignId), Number(missionId));

	const firstRenderAmplitude = useRef<boolean>(true);
	useEffect(() => {
		if (missions?.[0] && firstRenderAmplitude.current) {
			firstRenderAmplitude.current = false;
			amplitudeAddTrack(determineProjectName(missions?.[0]?.name ? `Misión: ${missions?.[0]?.name}` : 'Misión'), {
				title: determineProjectName(missions?.[0]?.name ? `Misión: ${missions?.[0]?.name}` : 'Misión'),
			})
		}
	}, [missions]);

  if (loadingCampaignOrParticipant) {
    return (
      <LoaderContainer>
        <SpaceshipLoader height="150px" />
      </LoaderContainer>
    )
  }
  if (!campaign || campaign && Object.keys(campaign)?.length === 0) {
    return (
      <EmptyGridMessageContainer>
        <img src={EmojiLookDown} alt="icon" />
        <h3>Está un poco vacío por aquí...</h3>
        <p>Participa en misiones para hacer crecer tu biblioteca.</p>
      </EmptyGridMessageContainer>
    )
  }
  return (
    <>
      <SEOHelmet
        metadata={{
          title: determineProjectName(missions?.[0]?.name ? `Misión: ${missions?.[0]?.name}` : 'Misión'),
          description: determineProjectName(missions?.[0]?.description ? `Misión: ${missions?.[0]?.description}` : 'Misión')
        }}
      />
      <MissionsRender
        requirements={requirements}
        missions={missions}
        participant={participant}
        campaign={campaign}
      />
    </>
  );
};

export default MissionPageV2;
